import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import { Size } from '../../constants.js';
import './FileInputField.scss.js';
import { Button, ButtonType } from '../Button/Button.js';
import { InputField } from '../InputField/InputField.js';
import { useId } from '../../utils/hooks/useId.js';

const bem = Bem.create("vai-file-input-field");
const FileInputField = React.forwardRef(function FileInputField2(props, ref) {
  const [files, setFiles] = React.useState([]);
  const {
    className,
    dataTa = "vai-file-input-field",
    disabled,
    name,
    width = Size.L,
    langFiles = " files",
    langBrowse = "Browse",
    placeholder = "Choose a file ...",
    invalid,
    fileNameInputRef,
    onFocus,
    tabIndex,
    fileInputProps
  } = props;
  const id = useId(props.htmlId, ["file input field"]);
  const fileInputRef = React.useRef(null);
  const onBrowseClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const onFileChange = (e) => {
    setFiles(e.currentTarget.files);
    if (props.onChange) {
      props.onChange(e);
    }
  };
  const filename = React.useMemo(() => {
    if (files != null && files.length > 0) {
      if (files.length === 1) {
        return files[0].name;
      }
      return `${files.length} ${langFiles ?? ""}`;
    } else {
      return "";
    }
  }, [files, langFiles]);
  return /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    "data-ta": dataTa,
    className: addClass(bem.block(), className, "vai-file-input", bem.element("input")(invalid && "invalid", width, disabled && "disabled")),
    ref
  }, /* @__PURE__ */ React.createElement("input", {
    id: id.copyWith(["input"]).toString(),
    ref: fileInputRef,
    type: "file",
    "data-ta": `${dataTa}-input`,
    className: "hidden",
    onChange: onFileChange,
    ...fileInputProps
  }), /* @__PURE__ */ React.createElement("span", {
    id: id.copyWith(["browse", "link"]).toString(),
    onClick: disabled ? void 0 : onBrowseClick
  }, /* @__PURE__ */ React.createElement(InputField, {
    htmlId: id.copyWith(["file name"]).toHtmlId(),
    innerRef: fileNameInputRef,
    disabled: true,
    value: filename,
    name,
    invalid,
    width,
    placeholder
  })), /* @__PURE__ */ React.createElement(Button, {
    htmlId: id.copyWith(["browse"]).toHtmlId(),
    className: bem.element("browse-button")(),
    buttonType: ButtonType.Secondary,
    buttonSize: Size.S,
    onClick: onBrowseClick,
    disabled,
    onFocus,
    tabIndex
  }, langBrowse));
});
FileInputField.metaProperties = ["invalid", "disabled"];

export { FileInputField };
